module.exports = __webpack_public_path__ + "img/HSAstore_Logo.1877478b.svg";